import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import DragAndDrop from './DragAndDrop';
import Toaster from '../../../../Components/Toaster/Toaster';
import Loader from '../../../../Components/Spinner/Loader';
import CategorySelectSearchField, {
  ICategory,
} from '../../../../Components/Common/CategorySelectSearchField';
import { Button } from 'react-bootstrap';
import { useCreateProductAndService } from '../../apiEndpoints/exhibitorApiEndpoints';

const AddProductAndServices = ({
  setToggle,
}: {
  setToggle: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const Toast = Toaster();
  const [files, setFiles] = useState<any>([]);

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();

  const { mutate, isSuccess, isPending } = useCreateProductAndService();

  useEffect(() => {
    if (isSuccess) {
      setToggle(false);
      reset();
      setFiles([]);
    }
  }, [isSuccess]);
  const onSubmit = async (data: any) => {
    if (!files.length) {
      Toast.fire({
        icon: 'error',
        title: `please add at least one image`,
      });

      return;
    }
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    files.forEach((img: any, index: number) => {
      const name = 'img_' + (index + 1);
      formData.append(name, img);
    });

    mutate(formData);
  };
  return (
    <div>
      <div className='col-md-12 mb-4 mt-3'>
        <div className='front-card '>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='row'>
              <div className='form-group col-xs-12 col-md-6'>
                <label>Product Name </label>
                <input
                  type='text'
                  className='form-control '
                  {...register('fair_member_product_name')}
                  placeholder='Enter Product Name'
                  id='productName'
                  required
                />
              </div>
              <div className='form-group col-md-6 mb-3'>
                <label className='d-flex justify-content-between'>
                  <div className='w-50'>
                    <span className='special_price'></span>Product{' '}
                    <span className='price_range d-none'>Start</span> Price{' '}
                    <span className='require'>*</span>
                  </div>
                </label>
                <input
                  type='number'
                  className='form-control '
                  {...register('fair_member_product_price')}
                  placeholder='product price'
                  id='price_start'
                />
              </div>

              <div className='form-group col-md-6 mb-3'>
                <label className='special_price'>Special Price</label>
                <div className='d-flex justify-content-between align-items-center'>
                  <input
                    type='number'
                    className='form-control special_price'
                    placeholder='specual price'
                    id='special_price'
                    {...register('fair_member_special_product_price')}
                  />
                </div>
              </div>

              <div className='form-group col-md-6 mb-3'>
                <Controller
                  name='category_id'
                  control={control}
                  rules={{ required: 'Product category is required' }}
                  render={({ field, fieldState }) => {
                    return (
                      <CategorySelectSearchField
                        label='Product Category'
                        onChange={(e: ICategory | null) =>
                          field.onChange(e?.id)
                        }
                        placeholder='Category'
                      />
                    );
                  }}
                />
                <span style={{ color: 'red', fontSize: 14 }}>
                  {errors && (errors as any)['category_id']?.message}
                </span>
              </div>

              <div className='form-group col-md-6 mb-3'>
                <label>Product URL </label>
                <input
                  type='url'
                  className='form-control'
                  placeholder='Enter Product Url'
                  id='product_url'
                  {...register('fair_member_product_url')}
                />
              </div>

              <div className='form-group col-md-12 mb-3'>
                <label>
                  Product Description <span className='require'>*</span>
                </label>
                <textarea
                  className='form-control '
                  placeholder='Enter Product Description'
                  id='description'
                  {...register('fair_member_product_description')}
                ></textarea>
                <div className='text-end'>
                  <small id='description_msg'>
                    Must be 10-500 words in length; written:{' '}
                  </small>
                </div>
              </div>
              <div className='form-group mb-0 dropzone-group light-style mb-3'>
                <div
                  className='alert alert-danger alert-dismissible image_upload_errors d-none'
                  role='alert'
                ></div>

                <label>
                  Product Images <span style={{ color: 'red' }}>(Max 4)</span>{' '}
                  <span className='require'>*</span>{' '}
                  <small>
                    <span className='request-time'>
                      Photo Must be JPG, JPEG, GIF or PNG and max file size 2MB.
                      For Best View Photo 500 x 250px
                    </span>
                  </small>
                </label>

                <div>
                  <div className='dz-message needsclick text-center'>
                    <DragAndDrop setFiles={setFiles} files={files} />
                  </div>
                </div>
              </div>

              <div className='form-group col-md-12 mb-3 text-end'>
                {isPending ? (
                  <Loader css={'btn'} />
                ) : (
                  <Button type='submit' className='submit-button'>
                    Create Product & Service
                  </Button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddProductAndServices;
